

const markupLinkRegex = /\[([^\]]+)\]\(((?:\/|https?:\/\/)[^\s]+)\)/; // recognize markup format: [description](url)
export function parseUrlMarkup(string) {
	if (string.search(markupLinkRegex) > -1) {
		let parsedUrl = string.replace(new RegExp(markupLinkRegex, 'g'), (element) => {
			const [, text, url] = element.match(markupLinkRegex);
			return `<a target="_blank" href="${url}">${text}</a>`;
		});
		return parsedUrl?.length > 0 ? parsedUrl : string;
	} else {
		return string;
	}
}